<section id="zeiten"  [ngClass]="{'dark': isDarkmode, 'light': !isDarkmode}" [class.isCapacitor]="platform.is('capacitor')">

  <div class="time" >
    <!-- <h2>Soll/Ist</h2> -->
    <div>
      <div>
        <table>
            <tr>
                <td>Soll:</td>
                <td>{{ticketSrv.targetTimeString}}</td> 
            </tr>
            <tr>
                <td>Ist:</td>
                <td style="color: var(--green)"> {{ticketSrv.totalTimeAsText}}</td>
            </tr>
          </table>
        </div>
        <div class="hover-bttn" (click)="setTargetTime($event)">
          <ion-icon name="fa-pen"></ion-icon>
        </div>
    </div>
    <timeline *ngIf="ticketSrv.targetTime > 0" [percent]="ticketSrv.timeDifferenceInPercent"></timeline>
  </div>

  <div class="filter-bttn" (click)="selectTimeArt($event)">
    <div>
      {{zeiten.activeTimeFilterValue.description}}
    </div>
    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="sort-down" class="svg-inline--fa fa-sort-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="currentColor" d="M311.9 335.1l-132.4 136.8C174.1 477.3 167.1 480 160 480c-7.055 0-14.12-2.702-19.47-8.109l-132.4-136.8C-9.229 317.8 3.055 288 27.66 288h264.7C316.9 288 329.2 317.8 311.9 335.1z"></path></svg>
  </div>
  <div id="time-buttons" *ngIf="!ticketSrv.isLoading">
    <div class="start-button start" *ngIf="(zeiten.activeTimeFilterValue.id == 0 && !hasNullableTaskIdInPersonal) || (zeiten.activeTimeFilterValue.id != 0 && zeiten.activePersonalTimes.length == 0)" (click)="startStopTime(true)">
      <ion-icon name="fa-play"></ion-icon>
      <span>Starten</span>
    </div>
    <div class="start-button stop" *ngIf="(zeiten.activeTimeFilterValue.id == 0 && hasNullableTaskIdInPersonal) || (zeiten.activeTimeFilterValue.id != 0 && zeiten.activePersonalTimes.length > 0)" (click)="startStopTime(false)">
      <ion-icon name="fa-sqaure"></ion-icon>
      <span>Stop</span>
    </div>
    <div id="time-add" class="hover-bttn" (click)="addTime()">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="plus" class="svg-inline--fa fa-plus fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"></path></svg>
    </div>
  </div> 
  <!-- <section *ngIf="((activeWorkstepTimes.length > 0 && zeiten.activeTimeFilterValue.id == 0 ) || (zeiten.activeTimeFilterValue.id > 0 && zeiten.activeWorkstepTime )) && !ticketSrv.isLoading">
    <h2>Laufende Zeiten</h2>
    <app-time-overview-base-item *ngFor="let ticketBundle of activeWorkstepTimes" [ticketBundle]="ticketBundle" [show]="zeiten.activeTimeFilterValue.id == 0 || zeiten.activeTimeFilterValue.id == ticketBundle.taskId" [canOpenTicket]="false"></app-time-overview-base-item>
  </section> -->

  <h2 *ngIf="zeiten.activePersonalTimes.length > 0">Meine Zeiten</h2>
  <app-time-overview-base-item *ngFor="let ticketBundle of zeiten.activePersonalTimes" [ticketBundle]="ticketBundle" [canOpenTicket]="false"></app-time-overview-base-item>

  <h2 *ngIf="zeiten.activeExternalTimes.length > 0 || externalTimes.length > 0">Andere Zeiten</h2>
  <app-time-overview-base-item *ngFor="let ticketBundle of zeiten.activeExternalTimes" [ticketBundle]="ticketBundle" [canOpenTicket]="false"></app-time-overview-base-item>
  <app-time-overview-base-item *ngFor="let ticketBundle of externalTimes" [ticketBundle]="ticketBundle" [canOpenTicket]="false"></app-time-overview-base-item>

  
  <section #timessec style="position: relative;">
    <app-user-information #userInformation [employeeInformationPosition]="employeeInformationPosition" [class.userInformationAnimation]="employeeInformationPosition?.animation" [class.userInformationHidden]="!employeeInformationPosition.active" [class.userInformationShow]="employeeInformationPosition.active" [ngStyle]="{'bottom.px': employeeInformationPosition?.y, 'left.px': employeeInformationPosition?.x}"></app-user-information>
    
      <div class="date-item" *ngFor="let dItem of ticketSrv?.ticket?.timesGrouped">
        <div *ngIf="dItem.ticketZeit.length >=1 && !ticketSrv.isLoading">
          <h2 *ngIf="checkSectionHasTimes(dItem)">Datum: {{dItem.datum | timeFormat: 'DD.MM.YYYY'}}</h2>
              <div class="time-item" *ngFor="let tItem of dItem.ticketZeit" (click)="editTime(tItem)" [class.calculated]="tItem?.toCalculate == 1" [class.no-calculate]="tItem?.toCalculate == 2">
                <div *ngIf="zeiten.activeTimeFilterValue.id == 0 || zeiten.activeTimeFilterValue.id == tItem.taskId">
                  <div class="user-circle" (mouseenter)="userhover(tItem, $event)" (mouseleave)="userleave()">
                    <span>{{tItem.employeeName}}</span>
                  </div>
                  <div>
                    <div class="time-heading">
                      {{zeiten.getFormatedDate(tItem.timeFrom, 'HH:mm')}}  
                      <span style="vertical-align: middle;">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M502.6 278.6l-128 128c-12.51 12.51-32.76 12.49-45.25 0c-12.5-12.5-12.5-32.75 0-45.25L402.8 288H32C14.31 288 0 273.7 0 255.1S14.31 224 32 224h370.8l-73.38-73.38c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l128 128C515.1 245.9 515.1 266.1 502.6 278.6z"/></svg>
                      </span>
                    {{zeiten.getFormatedDate(tItem.timeTo, 'HH:mm')}} Uhr
                  </div>
                  <div class="time-text">Dauer: {{tItem | timeDifference: 'HH:mm:ss'}} Std.</div>
                  <div class="time-text">Gesamt: {{tItem | timeIntervalDifference: 'HH:mm:ss'}} Std.</div>
                  <div style="opacity: 1; font-weight: 600;" class="time-text">{{tItem.taskId | taskName}}</div>
                  <div *ngIf="tItem?.toCalculate == 1" class="time-text">(Berechnet)</div>
                  <div *ngIf="tItem.note" class="time-text">Notiz: {{tItem.note}}</div>
                  <div class="hover-options hover-bttn" *ngIf="tItem?.toCalculate != 1 && generalSrv.serverVersionGreaterThan('1.11.1')" (click)="openOptions($event, tItem)">
                    <ion-icon name="fa-ellipsis-vertical"></ion-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </section>

  <div *ngIf="ticketSrv.isLoading">
    <div class="custom-skeleton" *ngFor="let i of loadingCount">
      <div style="display: flex;">
        <ion-skeleton-text animated style="width: 50px; margin-right: 10px;"></ion-skeleton-text>
        <div>-</div>
        <ion-skeleton-text animated style="width: 50px; margin-left: 10px;"></ion-skeleton-text>
      </div>
      <ion-skeleton-text animated style="width: 110px"></ion-skeleton-text>
    </div>
  </div>
  <div *ngIf="ticketSrv?.ticket?.times?.length == 0 && !ticketSrv.isLoading" id="no-times">
    Keine Zeiten
  </div>

</section>